import { h } from 'hyperapp';
import Submit from '~/common/account/components/submit.jsx';
export default (({
  state
}) => h("div", {
  class: "actions mdui-clearfix"
}, h(Submit, {
  disabled: state.submitting,
  text: state.submitting ? '注册中…' : '注册'
})));